import React, { Fragment, MouseEventHandler } from 'react'
import PropTypes from 'prop-types'
import SvgIcon from './SvgIcon'
import IconProps from './IconProps'
import { classNames } from './utils'

interface BaseIconProps extends IconProps {
  onClick?: React.MouseEventHandler<SVGElement>,
  style?: object,
}

export default class BaseIcon extends React.Component<BaseIconProps> {
  static defaultProps = {
    color: 'currentColor',
    width: 24,
    height: 24,
    style: {},
    className: ''
  }
  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    name: PropTypes.string,
    color: PropTypes.string,
    viewBox: PropTypes.string,
    style: PropTypes.object,
    className: PropTypes.any,
    alt: PropTypes.string,
  }

  getChildren: () => any[]
  getViewBox: () => string
  getColor = () => {
    return this.props.color
  }

  render(): React.ReactNode {
    const { alt, className: svgClassName } = this.props
    const viewBox = this.props.viewBox || this.getViewBox()

    const className = classNames('fc-icon', svgClassName)
    return <SvgIcon fill={ this.getColor() } className={ className } { ...this.props } viewBox={ viewBox }>
      { alt && <title>{ alt }</title> }
      { this.getChildren().map((el, index) => <Fragment key={ index }>{ el }</Fragment>) }
    </SvgIcon>
  }
}
